import { Badge } from "~/components/ui/badge";
import { OfferStatus } from "~/lib/schemas/db-enums";

interface Presentation {
  label: string;
  variant: "outline" | "success" | "cancelled";
  className?: string;
}

const PRESENTATION: Record<OfferStatus, Presentation> = {
  [OfferStatus.Draft]: {
    label: "Draft",
    variant: "outline",
    className: "border-amber-200 bg-amber-50 text-amber-800",
  },
  [OfferStatus.Published]: { label: "Published", variant: "success" },
  [OfferStatus.Retired]: { label: "Retired", variant: "cancelled" },
};

/** The coach-facing label for an offer's lifecycle status. */
export function OfferStatusBadge({ status }: { status: OfferStatus }) {
  const { label, variant, className } = PRESENTATION[status];
  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
}
